<template>
<form ref="form" method="GET" :action="action" @submit="onSubmit">
    <slot v-bind="{}"></slot>
</form>
</template>
<script>
import EventBus from "../utils/eventBus";

export default {
    name: 'navigation-form',
    props: ['action', 'pageHasBooking', 'anchor', 'partial-route'],

    data: () => ({
        query: '',
    }),

    methods: {
        onSubmit(event) {
            // @todo: dont reload page, if we already are on a page with a bookingForm available.
            // Code below is wip of that. still has some Vue mount/rerender Problems.
            // if(this.pageHasBooking) {
            //     event.preventDefault();
            //     const formData = new FormData(this.$refs.form);
            //     // let object = {};
            //     // formData.forEach((value, key) => {object[key] = value});
            //     // EventBus.$emit('dirs-form-update', object);
            //     this.query = new URLSearchParams(formData).toString();
            //     this.getRenderedPartial();
            //     // document.querySelector(`#${this.anchor}`).scrollIntoView({
            //     //     behavior: 'smooth'
            //     // });
            // }
        },
        async getRenderedPartial() {
            this.showLoading()
            let { data } = await axios.get(`${this.partialRoute}?${this.query}`);
            this.setResultContent(data);
        },

        setResultContent(html) {
            document.getElementById('dirs-booking-form').innerHTML = html;
        },

        showLoading() {
            this.setResultContent(this.loadingHtml());
        },

        loadingHtml() {
            return `
                <div class='flex items-center justify-center m-8'>
                    <img width='90' src='/assets/frontend/svg/loading_spinner.svg'>
                </div>
            `;
        }
    },
}
</script>
